import { render, staticRenderFns } from "./comp_CheckoutStep-confirm.vue?vue&type=template&id=909a0218&scoped=true&"
import script from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-confirm.vue?vue&type=style&index=0&id=909a0218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909a0218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
